import React, { useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../../components/layouts/main-layout";
import {
  PickListTableAction,
  PickListDashboardAction,
  ViewPickList,
  VoidPickList,
} from "../../../redux/actions/sales-action";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";
import BadgesComponent from "../../../components/tables/badges-component";
import TransSummaryComp from "../../../components/helper-components/trans-summary-comp";
import ArrowDownLeftIcon from "../../../assets/icons/sales-icons/arrow-down-left-icon";
import ClockIcon from "../../../assets/icons/sales-icons/clock-icon";
import FilmChartIcon from "../../../assets/icons/sales-icons/film-chart-icon";
import ChartIncreaseIcon from "../../../assets/icons/sales-icons/chart-increase-icon";

const PickListTable = () => {
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [reload, setReload] = useState(false);
  const [dashboard, setDashboard] = useState({
    received: 0,
    pending: 0,
    progress: 0,
    done: 0,
  });

  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "pick_list_no",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  });

  useEffect(() => {
    dispatch(
      PickListTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);

  useEffect(() => {
    dispatch(PickListDashboardAction({}, onDashboardSuccess, () => {}));
  }, [reload]);

  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.pickListTable ?? []);
    setDataCount(data?.data?.totalCount);
  };
  const onError = () => {
    setError(true);
    setLoading(false);
  };
  const onDashboardSuccess = (data) => {
    setDashboard({
      received: data?.data?.received ?? 0,
      pending: data?.data?.pending ?? 0,
      progress: data?.data?.progress ?? 0,
      done: data?.data?.done ?? 0,
    });
  };

  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };

  const tableBodyData = orders?.map((item) => {
    return {
      id: item?.pick_list_id,
      pick_list_no: (
        <span className="fw_500 cursor-pointer">
          {item?.pick_list_no ?? "--"}
        </span>
      ),
      cmr_name: item?.cmr_name ?? "--",
      cmr_id: item?.cmr_id ?? "--",
      pick_list_order_status: item?.status ?? "",
      pick_list_status: <BadgesComponent status={item?.status} extra='ly Picked'/>,
      total_qty: item?.total_qty ?? 0,
      total_bins: item?.total_bins ?? 0,
      picker_name: item?.picker_name ?? "--",
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "-",
      updated_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "-",
    };
  });

  const statCards = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total Pick List Received",
      value: `${dashboard.received}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
      icon: <ArrowDownLeftIcon />,
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Pending",
      value: `${dashboard.pending}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
      icon: <ClockIcon />,
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "In Progress",
      value: `${dashboard.progress}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
      icon: <FilmChartIcon />,
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Done",
      value: `${dashboard.done}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
      icon: <ChartIncreaseIcon />,
    },
  ];

  const summaryArray = statCards?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {statCards?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  return (
    <InnerLayout permissionFn={permissionFn} module="picklist" list={true} title="Pick List">
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <DynamicTransactionTable
          canCreateStandAlone={false}
          transaction="Pick List"
          transaction_type="pick_list"
          module="picklist"
          is_checkbox_req={true}
          invoiceItems={invoiceItems}
          setInvoiceItems={setInvoiceItems}
          transactionKey="pick_list"
          ViewAction={ViewPickList}
          deleteAction={VoidPickList}
          tableHeading1={tableHeading1}
          options={[{ value: "delivery", label: "Delivery Note" }]}
          handleSelect={(item) => {
            if (item?.value === "delivery") {
              navigate(
                `/add-delivery/${encodeURIComponent(
                  JSON.stringify(invoiceItems)
                )}/picklist?auto&transfer=true`
              );
            }
          }}
          filterSec={true}
          orders={orders}
          setOrders={setOrders}
          tableHeading={tableHeading}
          onClickItemFn={(id) => navigate(`/view-picklist/${id}`)}
          list={true}
          permissionFn={permissionFn}
          path="picklist"
          actionsPermissions={{
            edit: ["draft", "partial"],
            print: ["open", "closed"],
            delete: ["draft", "open"],
          }}
          reload={reload}
          setReload={setReload}
          loading={loading}
          setLoading={setLoading}
          label="Pick List"
          setFilterData={setFilterData}
          filterData={filterData}
          paginationProps={paginationProps}
          tableBodyData={tableBodyData}
          placeholder="Search (/)"
          initialFilter={{
            sort_by: "",
            sort_order: "",
            selectColumn: "pick_list_no",
            from: "",
            to: "",
            inputValue: "",
            orderStatus: "",
          }}
          summaryArray={summaryArray}
        />
      )}
    </InnerLayout>
  );
};

export default PickListTable;

const tableHeading1 = [
  { label: "ITEM CODE", value: "item_code" },
  { label: "BATCH NO", value: "item_batch_number" },
  { label: "BIN LOCATION", value: "bin_location_no" },
  { label: "QTY PICKED", value: "qty_to_pick" },
  { label: "UOM", value: "uom_name" },
];

const tableHeading = [
  {
    label: "PICKLIST NUMBER",
    value: "pick_list_no",
    display: false,
    column: true,
    minWidth: 160,
  },
  {
    label: "CUSTOMER NAME",
    value: "cmr_name",
    display: false,
    column: true,
    minWidth: 220,
  },
  {
    label: "STATUS",
    value: "pick_list_status",
    display: false,
    column: false,
    minWidth: 130,
  },
  {
    label: "QTY",
    value: "total_qty",
    display: true,
    column: false,
    alignment: "right",
    minWidth: 90,
  },
  {
    label: "BINS",
    value: "total_bins",
    display: true,
    column: false,
    alignment: "right",
    minWidth: 90,
  },
  {
    label: "ASSIGNEE",
    value: "picker_name",
    display: false,
    column: false,
    minWidth: 160,
  },
  {
    label: "UPDADTED DATE",
    value: "updated_date",
    display: false,
    column: false,
    minWidth: 150,
  },
  {
    label: "CREATED DATE",
    value: "created_date",
    display: false,
    column: false,
    minWidth: 150,
  },
  {
    label: "ACTION",
    value: "actions",
    display: false,
    column: false,
    minWidth: 110,
  },
];
